import { toast } from 'sonner';

/**
 * Replacement for window.confirm() that works in cross-origin iframes.
 * Returns a Promise that resolves to true (confirmed) or false (cancelled/dismissed).
 */
export function confirmAction(message, { confirmLabel = 'Confirm', cancelLabel = 'Cancel' } = {}) {
  return new Promise((resolve) => {
    const id = toast(message, {
      duration: 10000,
      action: {
        label: confirmLabel,
        onClick: () => {
          toast.dismiss(id);
          resolve(true);
        },
      },
      cancel: {
        label: cancelLabel,
        onClick: () => {
          toast.dismiss(id);
          resolve(false);
        },
      },
      onDismiss: () => resolve(false),
      onAutoClose: () => resolve(false),
    });
  });
}
